import axios from 'axios';

export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'development' ? '' : 'https://api.teleringprocess.in');

// Create the axios instance
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Normalize URL: remove any unwanted '/api' prefix since backend routes are mounted at root
    if (config.url) {
      config.url = config.url
        .replace(/^https?:\/\/api\.teleringprocess\.in\/api\//, 'https://api.teleringprocess.in/')
        .replace(/^\/?api\//, '/');
    }

    // Retrieve the access token from local storage
    const accessToken = localStorage.getItem('token');
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }

    // Retrieve the session_id cookie if needed
    const sessionId = document.cookie
      .split('; ')
      .find((row) => row.startsWith('session_id='))
      ?.split('=')[1];

    if (sessionId) {
      config.headers['Cookie'] = `session_id=${sessionId}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { axiosInstance };
export default axiosInstance;
